export const saveIsler = (tasks) => {
  try {
    localStorage.removeItem('isler');
    localStorage.setItem('isler', JSON.stringify(tasks));
  } catch (error) {
    localStorage.removeItem('isler');
  }
};

export const loadIsler = () => {
  try {
    const isler_txt = localStorage.getItem('isler');
    return isler_txt === null ? [] : JSON.parse(isler_txt);
  } catch (error) {
    return [];
  }
};
